import { useMemo } from "react";
import { VendorJobRequestChannelPage } from "../vendor-job-request-channel.page";
import { useCentralStore } from "../../../store/Central";
import { useJobStore } from "../../../store/Jobs";

export const VendorJobRequestChannelPageConnected = () => {
	const { organizationId, userId, clients } = useCentralStore((s) => ({
		organizationId: s.organization?.id ?? "",
		userId: s.profile?.id ?? "",
		clients: Object.values(s.clientsLookup),
	}));
	const { shareFile, unshareFile, acceptJobRequest, denyJobRequest } =
		useJobStore((s) => ({
			shareFile: s.shareFile,
			unshareFile: s.unshareFile,
			acceptJobRequest: s.acceptJobRequest,
			denyJobRequest: s.denyJobRequest,
		}));

	const clientOrganizationIds = useMemo(
		() =>
			clients
				.map((c) => c.connected_organization_id)
				.filter((id): id is string => id !== null),
		[clients]
	);

	return (
		<VendorJobRequestChannelPage
			organizationId={organizationId}
			userId={userId}
			clientOrganizationIds={clientOrganizationIds}
			onShareFile={shareFile}
			onUnshareFile={unshareFile}
			onAcceptJobRequest={acceptJobRequest}
			onDenyJobRequest={denyJobRequest}
		/>
	);
};
